<template>
  <div id="step-one">
    <el-form
      label-width="100px"
      style="width:800px;"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item style="margin-bottom:5px;">
        <div
          class="linkUpper"
        >监控链接上限： {{bmcCampaigntype.havesingleLinkNum}} / {{bmcCampaigntype.singleLinkNum}}</div>
      </el-form-item>
      <el-form-item label="监控平台" prop="plateformValue">
        <el-select
          placeholder="请选择"
          v-model="ruleForm.plateformValue"
          size="small"
          clearable
        >
          <el-option
            v-for="(item,i) in bmcCampaigntype.plateform"
            :key="i"
            :label="item.name"
            :value="item.platform"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="监控类型" required prop="radio">
        <el-radio v-model="ruleForm.radio" label="0" class="radio-check-nromal">标价</el-radio>
        <el-radio v-model="ruleForm.radio" label="1" class="radio-check-nromal">到手价</el-radio>
      </el-form-item>
      <!-- 验证链接 -->
      <checkLink
        :radio="ruleForm.radio"
        :plateformValue="ruleForm.plateformValue"
        @checkLinks="checkLinks"
        ref="refcheckLink"
        @vertityLinkFlow="vertityLinkFlow"
        :canChekNum='bmcCampaigntype.singleLinkNum-bmcCampaigntype.havesingleLinkNum'
      ></checkLink>
      <el-form-item required prop="allcheckLinks">
        <el-input v-model="ruleForm.allcheckLinks" v-show="false"></el-input>
      </el-form-item>
      <el-form-item label="通知人微信">
        <div class="flex-start">
          <div>
            <el-select
              multiple
              size="small"
              v-model="ruleForm.wechat"
              placeholder="请选择账号"
              @focus="changeWechatList"
            >
              <el-option
                v-for="item in wechatNoticeList"
                :key="item.openid"
                :label="item.remark||item.nickname"
                :value="item.openid"
              ></el-option>
            </el-select>
          </div>
          <div style="margin-left:10px">
            <div class="normal-blue" @click="newAdd" style="cursor:pointer">新增通知人</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="confire_btn"
          size="small"
          @click="submitForm('ruleForm')"
          :disabled="toSecondbtn"
        >下一步</el-button>
      </el-form-item>
    </el-form>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>
<script>
import checkLink from "components/checkLink/checkLink";
import wxBindingComponent from "../../../../components/wxComponent/wxBindingComponent.vue";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { getItemId } from "@/libs/index";

export default {
  data() {
    return {
      showWechatUrl: false,
      ruleForm: {
        plateformValue: "",
        wechat: "",
        allcheckLinks: "",
        radio: null
      },
      rules: {
        plateformValue: [
          { required: true, message: "请填写监控平台", trigger: "blur" }
        ],
        radio: [{ required: true, message: "请选择监控类型", trigger: "blur" }],
        allcheckLinks: [
          { required: true, message: "请验证链接", trigger: "blur" }
        ]
      },
      toSecondbtn: true
    };
  },
  computed: {
    ...mapGetters(["bmcCampaigntype", "wechatNoticeList"]),
    ...mapState({
      userInfo: state => state.serviceReport.userinfo
    })
  },
  components: {
    checkLink,
    wxBindingComponent
  },
  mounted() {
    this.reqselectbmcCampaigntype();
    this.reqmonitorLinkCount();
    this.reqGetbmcwx(); //获取当前用户的信息
  },
  methods: {
    ...mapActions([
      "reqselectbmcCampaigntype",
      "reqmonitorLinkCount",
      "reqGetbmcwx",
      "monitorNoticeList"
    ]),
    ...mapMutations(["changeitemIds", "chanstep",'changeAddLinkOpenids']),
    setPushNoticePeople(){
      fetchGet("hcm/monitorLink/setPushNoticePeople", {ids:this.noticeids,openids:this.ruleForm.wechat.join(',')}).then(res=>{
        if(res.status==='10000'){
          this.$message.success('成功')
        }
      })
    },
    changeWechatList() {
      this.monitorNoticeList();
    },
    // 新增(扫码绑定)
    newAdd() {
      this.$refs.childWxBinding.getbmcwx('m',this.userInfo.bid)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.chanstep(1);
          this.setPushNoticePeople()
          this.$emit("toSecond");
        } else {
          return false;
        }
      });
    },
    vertityLinkFlow() {
      if (!this.ruleForm.plateformValue) {
        this.$message.error("请选择监控平台");
        return false;
      }
      if (!this.ruleForm.radio) {
        this.$message.error("请选择监控类型");
        return false;
      }
      this.$refs.refcheckLink.handleCheckTrue();
    },
    checkLinks(params) {
      let itemIds = [];
      params.forEach(item => {
        itemIds.push(getItemId(item));
      });
      this.changeitemIds(itemIds.join(","));
      let data = {
        platform: this.ruleForm.plateformValue,
        priceType: this.ruleForm.radio,
        itemIds: itemIds.join(",")
      };
      fetch({
        url: "hcm/monitorLink/verifiedLink",
        method: "post",
        data: data,
        timeout: 60 * 1000 * 10
      }).then(res => {
        if (res.status === "10000") {
          if (!/false/.test(res.data)&&!/服务器异常/.test(res.data)) {
            this.noticeids=res.data
            this.ruleForm.allcheckLinks = 1;
            // this.$message.success("验证链接成功,已自动剔除无效链接");
            this.$message.success("成功");
            this.$refs.refcheckLink.changecheckDisabled();
            this.toSecondbtn = false;
          } else {
            this.$message.error("验证链接失败!");
          }

        } else if(res.status === "10004"){
          this.$message.error(res.message);
          this.$refs.refcheckLink.verifiedRepeat(res.data);
          this.toSecondbtn = true;
          this.$refs.refcheckLink.cancheckDisabled();
        }
         this.$refs.refcheckLink.filechangecheckDisabled();
      }).catch(()=>{
        this.$refs.refcheckLink.filechangecheckDisabled();
        this.$refs.refcheckLink.cancheckDisabled();
      })
    }
  }
};
</script>
<style lang="scss">
#step-one {
  .code-qr {
    width: 100px;
    height: 100px;
    box-shadow: 7px 2px 18px #eeeeeebf;
  }
  .el-select .el-input__inner {
    width: 462px;
  }
  .linkUpper {
    color: #e90e24;
  }
  .delRedLink{
    margin-right: 31px;
  }
}
</style>
